import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import {
  emptyNodeDataObject,
  updateNodeSelectionNodeData,
  updateNodeSelectionNodeEditedState,
  updateNodeSelectionState,
  updateShowBulkEditDataAcquisitionTypeModal,
} from "@src/reducers/your-reducer";

import dataAcquisitionIcon from "@src/assets/svg/data-acquisition-blue-icon.svg";
import dataAcquisitionIconInactive from "@src/assets/svg/data-acquisition-inactive-blue-icon.svg";

export const useControlBarBulkModifyDataAcquisitionTypeButtonHook = () => {
  const dispatch = useDispatch();
  const machineStructureNodeset = getMachineStructureNodeset();

  const [selectedSize, setSelectedSize] = useState(0);

  const closePanelAndFlushNodeData = () => {
    dispatch(updateNodeSelectionNodeData(emptyNodeDataObject));
    dispatch(updateNodeSelectionNodeEditedState(false));
    dispatch(updateNodeSelectionState("none"));
  };

  const openDataAcquisitionBulkEditModal = () => {
    closePanelAndFlushNodeData();
    dispatch(updateShowBulkEditDataAcquisitionTypeModal(true));
  };

  useEffect(() => {
    const countSelectedVariables = () => {
      const count = machineStructureNodeset.getSelectedVariablesCount();
      setSelectedSize(count);
    };

    machineStructureNodeset.addObserver(countSelectedVariables);
    return () => {
      machineStructureNodeset.removeObserver(countSelectedVariables);
    };
  }, [machineStructureNodeset]);

  const icon =
    selectedSize > 1 ? dataAcquisitionIcon : dataAcquisitionIconInactive;
  const disabled = selectedSize <= 1;

  return {
    icon,
    disabled,
    openDataAcquisitionBulkEditModal,
  };
};
